import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./NewObjectiveForm.css";

function NewObjectiveForm() {
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [dueDate, setDueDate] = useState(new Date());
  const [bossObjective, setBossObjective] = useState("");
  const [bossObjectives, setBossObjectives] = useState([]);
  const [availableWeight, setAvailableWeight] = useState(100);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/user/weight/${state.userId}`,
        data: {
          status: "active",
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAvailableWeight(response.data.availableWeight);
      setBossObjectives(response.data.bossObjectives);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId]);

  const handleSubmit = async () => {
    try {
      if (validateWeight(weight)) {
        await axios({
          method: "post",
          url: `${process.env.REACT_APP_BACKEND_URL}/objectives`,
          data: {
            description: description,
            weight: weight,
            dueDate: dueDate,
            bossObjectiveId: bossObjective,
            userId: state.userId,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        navigate("/myobjectives");
      } else {
        handleShow();
      }
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const validateWeight = (weight) => {
    if (weight > availableWeight) {
      return false;
    } else {
      return true;
    }
  };

  const handleDescriptionChange = (evt) => {
    setDescription(evt.target.value);
  };

  const handleWeightChange = (evt) => {
    setWeight(evt.target.value);
  };

  const handleBossObjectiveChange = (evt) => {
    setBossObjective(evt.target.value);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="new-objective-header">
            <h2>{t("Objetivos.NewForm.Titulo")}</h2>
          </Col>
        </Row>
        <Row>
          <Col className="new-objective-form">
            <Col className="availble-weight">
              <h5>
                {t("Objetivos.NewForm.PonderacionDisponible")}:{" "}
                {availableWeight}
              </h5>
            </Col>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.NewForm.ObjetivoJefeDirecto")}
                </Form.Label>
                <Form.Select onChange={handleBossObjectiveChange}>
                  <option value="">
                    {t("Objetivos.NewForm.SeleccionarObjetivo")}
                  </option>
                  {bossObjectives.map((objective) => (
                    <option key={objective._id} value={objective._id}>
                      {objective.description}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("Objetivos.NewForm.Descripcion")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={t("Objetivos.NewForm.IngresaDescripcion")}
                  onChange={handleDescriptionChange}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("Objetivos.NewForm.Ponderacion")}</Form.Label>
                <Row className="justify-content-center align-items-center">
                  <Col lg={11}>
                    <Form.Range
                      defaultValue={weight}
                      name="weight"
                      onChange={(e) => handleWeightChange(e)}
                    />
                  </Col>
                  <Col lg={1}>
                    <span className="weightVal">{weight}</span>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{t("Objetivos.NewForm.FechaMeta")}</Form.Label>
                <DatePicker
                  selected={dueDate}
                  name="dueDate"
                  onChange={(date) => setDueDate(date)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Button className="primary" onClick={handleSubmit}>
                  {t("Objetivos.NewForm.Guardar")}
                </Button>
                <Link to="/objectives">
                  <Button className="danger">
                    {t("Objetivos.NewForm.Cancelar")}
                  </Button>
                </Link>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Objetivos.NewForm.PonderacionExcedida")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{t("Objetivos.NewForm.PonderacionExcede")}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Objetivos.NewForm.Cerrar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default NewObjectiveForm;
